/* FASHIONSHUBS — welcome popup (HUBS10) */
(function () {
  var KEY = 'fh_popup', CODE = 'HUBS10', DELAY = 5000, SNOOZE_DAYS = 7;
  var IMG = 'https://cdn.shopify.com/s/files/1/0854/4174/1048/files/fashionshubs-popup.jpg?v=1790330179';
  var p = location.pathname;
  if (/^\/(cart|checkout|account|challenge|password)/.test(p) || window.Shopify && Shopify.designMode) return;
  var st; try { st = JSON.parse(localStorage.getItem(KEY) || '{}'); } catch (e) { st = {}; }
  if (st.done || (st.until && Date.now() < st.until)) return;
  var save = function (o) { try { localStorage.setItem(KEY, JSON.stringify(o)); } catch (e) {} };

  var el = document.createElement('div');
  el.className = 'fhw'; el.setAttribute('role', 'dialog'); el.setAttribute('aria-modal', 'true'); el.setAttribute('aria-labelledby', 'fhw-t');
  el.innerHTML =
    '<div class="fhw__bg" data-close></div><div class="fhw__box">' +
    '<button class="fhw__x" type="button" aria-label="Close" data-close>&times;</button>' +
    '<div class="fhw__img"><img src="' + IMG + '&width=1000" alt="Luxury handbags from FASHIONSHUBS" loading="lazy"></div>' +
    '<div class="fhw__body" data-step="form">' +
      '<p class="fhw__eyebrow">Welcome to FASHIONSHUBS</p>' +
      '<h2 class="fhw__title" id="fhw-t">10% Off</h2>' +
      '<p class="fhw__sub">Your First Order</p>' +
      '<p class="fhw__text">Join our private list for early access to rare arrivals, and receive your welcome code by email.</p>' +
      '<form class="fhw__form" novalidate><input type="email" name="email" placeholder="Enter your email address" autocomplete="email" inputmode="email" enterkeyhint="go" required aria-label="Email address">' +
      '<p class="fhw__err" hidden></p><button class="fhw__btn" type="submit">Unlock 10% Off</button></form>' +
      '<button class="fhw__no" type="button" data-close>No thanks, I\'ll pay full price</button>' +
      '<p class="fhw__legal">By signing up, you agree to receive marketing emails. Unsubscribe anytime. See our <a href="/policies/privacy-policy">Privacy Policy</a>.</p>' +
    '</div></div>';

  var shown = false; var open = function () { if (shown) return; shown = true; document.body.appendChild(el); requestAnimationFrame(function () { el.classList.add('is-open'); }); var i = el.querySelector('input'); if (window.matchMedia('(min-width: 750px)').matches) setTimeout(function () { i && i.focus({ preventScroll: true }); }, 400); };
  var close = function () {
    el.classList.remove('is-open'); setTimeout(function () { el.remove(); }, 400);
    if (!st.done) save({ until: Date.now() + SNOOZE_DAYS * 864e5 });
  };
  el.addEventListener('click', function (e) { if (e.target.closest('[data-close]')) close(); });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape' && el.isConnected) close(); });

  el.querySelector('form').addEventListener('submit', function (e) {
    e.preventDefault();
    var f = e.target, email = f.email.value.trim(), err = f.querySelector('.fhw__err'), btn = f.querySelector('button');
    if (!/^[^\s@]+@[^\s@]+\.[^\s@]{2,}$/.test(email)) { err.textContent = 'Please enter a valid email address.'; err.hidden = false; return; }
    err.hidden = true; btn.disabled = true; btn.textContent = 'Please wait…';
    var fd = new FormData();
    fd.append('form_type', 'customer'); fd.append('utf8', '✓');
    fd.append('contact[email]', email); fd.append('contact[tags]', 'newsletter,welcome-popup');
    fetch('/contact', { method: 'POST', body: fd, credentials: 'same-origin' }).catch(function () {}).then(function () {
      st = { done: true }; save(st);
      var b = el.querySelector('.fhw__body');
      b.innerHTML = '<p class="fhw__eyebrow">Welcome to the list</p><h2 class="fhw__title" id="fhw-t">Thank You</h2>' +
        '<p class="fhw__text">Here is your 10% welcome code. We have also sent it to <strong></strong>.</p>' +
        '<div class="fhw__code"><span>' + CODE + '</span><button class="fhw__copy" type="button">Copy</button></div>' +
        '<p class="fhw__text" style="font-size:.74rem">Enter it at checkout. Valid once per customer, on the entire store.</p>' +
        '<button class="fhw__btn" type="button" data-close>Start Shopping</button>';
      b.querySelector('strong').textContent = email;
      b.querySelector('.fhw__copy').addEventListener('click', function (ev) {
        var t = ev.currentTarget;
        (navigator.clipboard ? navigator.clipboard.writeText(CODE) : Promise.reject()).then(function () { t.textContent = 'Copied'; }).catch(function () { window.prompt('Copy your code:', CODE); });
      });
    });
  });

  var pending = function () { var b = document.querySelector('.shopify-pc__banner__wrapper'); return !!(b && b.getBoundingClientRect().height > 0); };
  var timer, tryOpen = function () { if (pending()) { timer = setTimeout(tryOpen, 1000); return; } open(); };
  timer = setTimeout(tryOpen, DELAY);
  document.addEventListener('mouseout', function ex(e) { if (!e.relatedTarget && e.clientY < 5) { if (pending()) return; clearTimeout(timer); document.removeEventListener('mouseout', ex); open(); } });
})();
